import type { InternalAxiosRequestConfig } from "axios";
import { authInstance } from "./authInstance";

export const requestInterceptor = async (config: InternalAxiosRequestConfig) => {
    while (typeof authInstance.token !== "string") {
        if (authInstance.token === null) {
            return config;
        }

        if (authInstance.token === undefined) {
            const promise = new Promise<string | null | undefined>((resolve) => {
                const clearListener = authInstance.addStateChangeListener((state) => {
                    clearListener();
                    resolve(state.token);
                });
            });

            await promise;
        }
    }

    config.headers = config.headers ?? {};
    config.headers.Authorization = `Bearer ${authInstance.token}`;
    return config;
};
